// extracted by mini-css-extract-plugin
module.exports = {"sizeIcon":"buyCompleted_sizeIcon__4PwO6"};